<div class="v3 d-inline-flex">
    <ng-container>
        @switch (mode) {
            @case (ProfileCardMode.Avatar) {

                <div class="v3 d-inline-flex">
                    <div
                        class="sb-avatar-container"
                        [ngClass]="{
                            'flex-column': (!isMobileOrTablet || size === ProfileImageSize.Edit) && orientation === Orientation.Vertical,
                            'flex-row': (isMobileOrTablet && size !== ProfileImageSize.Edit) || orientation === Orientation.Horizontal
                        }">
                        <ng-content select="[avatarHeader]"></ng-content>
                        <ng-container *ngTemplateOutlet="avatar"></ng-container>

                        @if (size === ProfileImageSize.Edit) {
                            <div
                                class="d-flex align-items-center gap-2"
                                [ngClass]="{ 'pt-4': orientation === Orientation.Vertical, 'ps-4': orientation === Orientation.Horizontal }">
                                <lib-button
                                    [kind]="ButtonKind.Secondary"
                                    [prefixIcon]="hasImageToShow ? Icon.Common.Edit : Icon.Common.Add"
                                    (clicked)="AddOrEditProfileImage()"
                                    [qaTag]="qaTag ? qaTag + '-edit-button' : ''">
                                    <ng-container label>
                                        @if (hasImageToShow) {
                                            <ng-container
                                                i18n="@@CommonEditButton">
                                                Edit
                                            </ng-container>
                                        } @else {
                                            <ng-container
                                                i18n="@@CommonAddButton">
                                                Add
                                            </ng-container>
                                        }
                                    </ng-container>
                                </lib-button>
                                @if (hasImageToShow) {
                                    <lib-button
                                        [kind]="ButtonKind.Secondary"
                                        [prefixIcon]="Icon.Common.DeleteOutline"
                                        [iconOnly]="true"
                                        (clicked)="DeletePreviewProfileImage()"
                                        [qaTag]="qaTag ? qaTag + '-delete-button' : ''">
                                        <ng-container
                                            label
                                            i18n="@@CommonDeleteButton">
                                            Delete
                                        </ng-container>
                                    </lib-button>
                                }
                            </div>
                        }
                        @if (showName) {
                            <div
                                class="d-flex flex-column gap-1 sb-profile-image-name-container"
                                [ngClass]="{
                                    'align-items-center': !isMobileOrTablet,
                                    'padding-left-8': isMobileOrTablet && !hideAvatar,
                                    'pe-2': isMobileOrTablet && hideAvatar
                                }">
                                <h4
                                    [attr.data-sb-qa]="qaTag ? qaTag + '-name' : ''"
                                    class="sb-profile-image-name"
                                    data-clarity-mask="true"
                                    [ngClass]="{
                                        'pt-4': !hideAvatar && !isMobileOrTablet && orientation === Orientation.Vertical,
                                        'ps-4': !hideAvatar && !isMobileOrTablet && orientation === Orientation.Horizontal
                                    }"
                                    [matTooltip]="name">
                                    {{ name }}
                                </h4>

                                <!--
                                    when we do the conditional projection in the way of
                                    <ng-container title *ngIf="condition">{{contentText}}</ng-container>
                                    even the condition is false,
                                    titleContent.hasChildNodes() will still return a true value, because ngIf false will still leave a comment in the dom
                                    and since in this case we only project string, we can use .innerText instead of .hasChildNodes()
                                -->
                                <div
                                    class="typography-body-small "
                                    [ngClass]="{'d-flex justify-content-center': !isMobileOrTablet}"
                                    [hidden]="!titleContent.innerText"
                                    [attr.data-sb-qa]="qaTag ? qaTag + '-title' : ''">
                                    <div>
                                        <span
                                            class="base-200"
                                            i18n="@@CommonTitleColon">
                                            Title:
                                        </span>
                                        <span
                                            class="base-100"
                                            #titleContent>
                                            <ng-content select="[title]"></ng-content>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }
            @case (ProfileCardMode.Logo) {
                <div class="align-items-center">
                    <div
                        [ngClass]="{
                            'flex-column': !isMobileOrTablet,
                            'flex-row': isMobileOrTablet,
                            'align-items-center d-flex': !hasImageToShow && !isMobileOrTablet
                        }">
                        @if (!hasImageToShow) {
                        <div
                            class="rounded-circle d-flex align-items-center justify-content-center background-base-0"
                            [ngClass]="size">
                            <div
                                class="rounded-circle d-flex align-items-center justify-content-center overflow-hidden"
                                [ngClass]="backgroundColor">
                                <p class="text-nowrap">{{ initials | uppercase }}</p>
                            </div>
                        </div>
                        }
                    </div>
                    <div
                        [ngClass]="{
                            'd-flex align-items-center flex-column justify-content-center avatar-container': !isMobileOrTablet,
                            'logo-container gap-2': isMobileOrTablet
                        }">
                        @if (hasImageToShow) {
                            <div
                                class="background-base-0 p-2"
                                [class.sb-profile-image-loading]="imageLoading">
                                <img
                                    id="image-resize"
                                    imageResizer
                                    [src]="imageURL"
                                    (load)="ImageLoaded($event)"
                                    (error)="ImageLoaded($event)"
                                    i18n-alt="@@CommonProfilePictureLabel"
                                    alt="Profile Picture"
                                    i18n-title="@@CommonProfilePictureLabel"
                                    title="Profile Picture" />
                            </div>
                        }
                        @if (showName) {
                        <div
                            [ngClass]="{ 'd-grid': !isMobileOrTablet, 'd-flex align-items-center justify-content-center pt-4 gap-2': isMobileOrTablet }">
                            <h5
                                [attr.data-sb-qa]="qaTag ? qaTag + '-name-h5' : ''"
                                [ngClass]="{ 'pt-4 text-center': !isMobileOrTablet }"
                                class="text-truncate text-wrap typography-semibold"
                                data-clarity-mask="true"
                                [matTooltip]="name">
                                {{ name }}
                            </h5>
                            @if (isTablet && editable) {
                            <lib-button
                                [kind]="ButtonKind.Secondary"
                                [size]="ButtonSize.Small"
                                [qaTag]="qaTag ? qaTag + '-edit-button' : ''"
                                [prefixIcon]="Icon.Common.Edit"
                                [iconOnly]="true"
                                (clicked)="EditClicked()"></lib-button>
                            }
                        </div>
                        }
                    </div>
                </div>
            }
        }
    </ng-container>
</div>

<ng-template #avatar>
    <div
        class="sb-avatar"
        [ngClass]="[size, backgroundColor]">
        @if ((hasImageToShow && !isSoftDeleted) || imagePreview) {
        <div
            class="sb-avatar-image-container"
            [class.sb-profile-image-loading]="imageLoading">
            <img
                data-clarity-mask="true"
                [src]="(imageURL | trustUrl) | method: GetImage : imagePreview"
                (load)="ImageLoaded($event)"
                (error)="ImageLoaded($event)"
                i18n-alt="@@CommonProfilePictureLabel"
                alt="Profile Picture"
                i18n-title="@@CommonProfilePictureLabel"
                title="Profile Picture" />
        </div>
        } @else if (imageLoading && !imagePreview && size !== ProfileImageSize.Edit) {
            <div class="sb-profile-image-skeleton"></div>
        } @else if ((!hasImageToShow && !imagePreview) || isSoftDeleted) {
            <div
                class="sb-avatar-initials"
                [ngClass]="size">
                <span>{{ initials | uppercase }}</span>
            </div>
        }
    </div>
</ng-template>